import { ChangeDetectorRef, Component, ElementRef, HostListener, Input, OnDestroy, Renderer2, SimpleChanges, ViewChild } from '@angular/core';
import { InstagramPostComponent } from '../instagram-post/instagram-post.component';
import { FacultadAutoridadesComponent } from '../facultad-autoridades/facultad-autoridades.component';
import { CommonModule } from '@angular/common';
import { SanitizeHtmlPipe } from '../../pipes/sanitize-html.pipe';

@Component({
  selector: 'app-facultad-informacion-inicial',
  standalone: true,
  imports: [CommonModule, InstagramPostComponent, FacultadAutoridadesComponent,SanitizeHtmlPipe],
  templateUrl: './facultad-informacion-inicial.component.html',
  styleUrl: './facultad-informacion-inicial.component.scss'
})
export class FacultadInformacionInicialComponent implements OnDestroy {
  @ViewChild('columnaContacto') columnaContacto!: ElementRef;
  @Input() info: any;
  @Input() language: string;
  isModalOpen: boolean = false;
  isOpen: boolean = false;
  alturaInicial: number | null = null;
  
  constructor(private eRef: ElementRef, private cdr: ChangeDetectorRef, private renderer: Renderer2) { }

  abrirModalAutoridades(): void {
    this.isModalOpen = true;
    this.renderer.addClass(document.body, 'facultad-modal-open');
  }

  cerrarModalAutoridades(): void {
    this.isModalOpen = false;
    this.renderer.removeClass(document.body, 'facultad-modal-open');
  }

  @HostListener('document:keydown.escape')
  cerrarModalConEscape(): void {
    if (this.isModalOpen) {
      this.cerrarModalAutoridades();
    }
  }

  ngOnDestroy(): void {
    this.renderer.removeClass(document.body, 'facultad-modal-open');
  }
  ngAfterViewInit() {
    this.calcularAltura();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['info'] && !changes['info'].firstChange) {
      this.calcularAltura();
    }
  }

private calcularAltura() {
  setTimeout(() => {
    let elemento = this.columnaContacto?.nativeElement;
    if (!elemento) {
      elemento = this.eRef.nativeElement.querySelector('.content2');
    }
    if (elemento) {
      this.alturaInicial = elemento.offsetHeight;
      this.cdr.detectChanges(); 
    } else {
      console.warn("No se encontró la columna de contacto en el DOM");
    }
  }, 100); 
}

  toggleDropdown(event: Event): void {
    event.stopPropagation(); 
    this.isOpen = !this.isOpen;
    console.log('Estado desplegable:', this.isOpen); 
  }

  @HostListener('document:click', ['$event'])
  clickout(event: Event): void {
    if (!this.eRef.nativeElement.contains(event.target)) {
      this.isOpen = false;
    }
  }

  goToUrl(btn: any) {
    const urlString = this.url(btn);

    if (!urlString) return;

    window.open(urlString, '_blank', 'noopener,noreferrer');
  }

  url(element: any): string {
    let link = element;

    if (!link) return '';

    if (this.isExternalUrl(link)) {
      return link;
    }

    if (link.startsWith('/')) {
      link = link.substring(1);
    }

    return `/${this.language}/${link}`;
  }

  isExternalUrl(urlStr: string): boolean {
    return urlStr.startsWith('http://') || urlStr.startsWith('https://');
  }
}
